import { addAction as addNRAction, addError as addNRError } from '@shared/utils/logger';

export function addError(error: unknown, context?: object): void {
  addNRError(error, context);
}

export function addAction(name: string, context?: object): void {
  addNRAction(name, context as Record<string, unknown>);
}
